export default __webpack_public_path__ + "static/media/book_freedom_c_philosophies.185a0eb6.png";